import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Container, Row, Col, Image, Card, InputGroup } from "react-bootstrap";
import configuration from "react-global-configuration";
import SocialButton from "../helper/SocialButton";
import { translate, t } from "react-multi-lang";
import { connect } from "react-redux";
import Slider from "react-slick";
import AuthFooter from "../layouts/Footer/AuthFooter";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import {
  forgotPasswordStart,
  userLoginStart,
  userRegisterStart,
  usernameValidationStart,
} from "../../store/actions/UserAction";
import api from "../../Environment";
import queryString from 'query-string'
import styles from './LandingPage.module.css';
import moment from "moment"
import {
  fetchTopPostVideosStart
} from "../../store/actions/PostAction";
import {
  fetchTopEarnersStart
} from "../../store/actions/SubscriptionAction";
import Header from "./Header";
import Banner from "./Banner";
import Features from "./Features"
import Earn from "./Earn";
import MostWatch from "./MostWatch";
import CreatorBanner from "./CreatorBanner";
import TopOfMonth from "./TopOfMonth";
import FAQ from "./FAQ";

const LandingPage = (props) => {

  useEffect(() => {
    // fetch top earners and top viewed videos when page load
    props.dispatch(fetchTopPostVideosStart());
    props.dispatch(fetchTopEarnersStart());
  }, [])

  return (
    <div className={styles.landingPage}>
      <Header />
      <Banner />
      <Features />
      <Earn />

      {!props.topPostVideos || props.topPostVideos.loading ? (
        <div className="text-white"> {t("loading")}</div>
      ) : (props.topPostVideos.data && props.topPostVideos.data.length ?
          <MostWatch topPostVideos={props.topPostVideos.data} />
        : <h5 className="text-muted">{t("rec_not_found")}</h5>
      )}

      <CreatorBanner />

      {!props.topEarners || props.topEarners.loading ? (
        <div className="text-white"> {t("loading")}</div>
      ) : (props.topEarners.data && props.topEarners.data.length ? (
          <TopOfMonth topEarners={props.topEarners.data} />)
        : <h5 className="text-muted">{t("rec_not_found")}</h5>
      )}
      <FAQ />

      {/* footer */}
      <footer className={styles.footer}>Copyrights 2026. All rights reserved.</footer>

    </div>
  );
};

const mapStateToPros = (state) => ({
  login: state.users.loginInputData,
  signup: state.users.registerInputData,
  forgotPassword: state.users.forgotPasswordInputData,
  validation: state.users.validationInputData,
  topPostVideos: state.post.topPostVideos,
  topEarners: state.subscriptions.topEarners,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(LandingPage));
